export const VALUE_INDEX = 0;
export const KEY_INDEX = 1;
export const PARENT_INDEX = 2;
export const POINTER_INDEX = 3;
